var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["../elements/combobox.html"] = require( "../elements/combobox.html" );




var shim = require("C:/Users/kaharmanny/source/repos/rentmagic.frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["views/interface/nav.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("../elements/combobox.html", false, "views/interface/nav.html", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("combo", t_1);
output += "\r\n\r\n<div class=\"nav-left col-4 col-md-4 col-sm-4 col-xs-4\">\r\n\t<div class=\"logo\">\r\n\t\t<span class=\"logo-icon infodatek-icon infodatek-icon-";
output += runtime.suppressValue(env.getFilter("lower").call(context, runtime.contextOrFrameLookup(context, frame, "product")), env.opts.autoescape);
output += "\"></span>\r\n\t\t<span class=\"logo-text\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "product"), env.opts.autoescape);
output += "</span>\r\n\t</div>\r\n</div>\r\n\r\n<div class=\"text-right col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8\">\r\n\t";
if(runtime.contextOrFrameLookup(context, frame, "kiosk") || !runtime.contextOrFrameLookup(context, frame, "canViewSettingsMenu")) {
output += "\r\n\t";
frame = frame.push();
var t_6 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "shortcuts")),"Top");
if(t_6) {var t_5 = t_6.length;
for(var t_4=0; t_4 < t_6.length; t_4++) {
var t_7 = t_6[t_4];
frame.set("shortcut", t_7);
frame.set("loop.index", t_4 + 1);
frame.set("loop.index0", t_4);
frame.set("loop.revindex", t_5 - t_4);
frame.set("loop.revindex0", t_5 - t_4 - 1);
frame.set("loop.first", t_4 === 0);
frame.set("loop.last", t_4 === t_5 - 1);
frame.set("loop.length", t_5);
output += "\r\n\t<button data-menu-id=\"";
output += runtime.suppressValue(runtime.memberLookup((t_7),"MenuID"), env.opts.autoescape);
output += "\" class=\"button button-default shortcut\">";
output += runtime.suppressValue(runtime.memberLookup((t_7),"Text"), env.opts.autoescape);
output += "</button>\r\n\t";
;
}
}
frame = frame.pop();
output += "\r\n\t<button class=\"button button-default\" data-canvas-event=\"logoff\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"Logout"), env.opts.autoescape);
output += "</button>\r\n\t";
;
}
else {
output += "\r\n\t<!--<button data-canvas-event=\"opencustomwindow:dateview:Date View:true\" class=\"button button-default shortcut\">test</button>-->\r\n\t";
frame = frame.push();
var t_10 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "shortcuts")),"Top");
if(t_10) {var t_9 = t_10.length;
for(var t_8=0; t_8 < t_10.length; t_8++) {
var t_11 = t_10[t_8];
frame.set("shortcut", t_11);
frame.set("loop.index", t_8 + 1);
frame.set("loop.index0", t_8);
frame.set("loop.revindex", t_9 - t_8);
frame.set("loop.revindex0", t_9 - t_8 - 1);
frame.set("loop.first", t_8 === 0);
frame.set("loop.last", t_8 === t_9 - 1);
frame.set("loop.length", t_9);
output += "\r\n\t<button data-menu-id=\"";
output += runtime.suppressValue(runtime.memberLookup((t_11),"MenuID"), env.opts.autoescape);
output += "\" class=\"button button-default shortcut d-none d-md-inline-block\">";
output += runtime.suppressValue(runtime.memberLookup((t_11),"Text"), env.opts.autoescape);
output += "</button>\r\n\t";
;
}
}
frame = frame.pop();
output += "\r\n\t";
if(runtime.contextOrFrameLookup(context, frame, "product") != "BorrowMe") {
output += "\r\n\t<div class=\"scanbox dropdown\">\r\n\t\t<div class=\"combobox d-block\">\r\n\t\t\t";
output += runtime.suppressValue((lineno = 23, colno = 27, runtime.callWrap(runtime.memberLookup((t_1),"constructCombobox"), "combo[\"constructCombobox\"]", context, [runtime.contextOrFrameLookup(context, frame, "this"),runtime.contextOrFrameLookup(context, frame, "scanbox")])), env.opts.autoescape);
output += "\r\n\t\t</div>\r\n\t</div>\r\n\t";
;
}
output += "\r\n\r\n\t<div class=\"dropdown\">\r\n\t\t<button class=\"button button-menu material-icons toggle-menu\">&#xe8b8;</button>\r\n\t\t<div class=\"menu hide\">\r\n\t\t\t<div class=\"option\" data-canvas-event=\"usersettings\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"LoggedInAs"), env.opts.autoescape);
output += ": ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "username"), env.opts.autoescape);
output += "</div>\r\n\t\t\t<div class=\"option composite\">\r\n\t\t\t\t<div class=\"item\">\r\n\t\t\t\t\t<button data-canvas-event=\"zoom:-0.05\" class=\"button min-plus mini-button\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"ZoomIn"), env.opts.autoescape);
output += "\">-</button>\r\n\t\t\t\t\t<span data-canvas-event=\"zoom:0\" data-zoom-value class=\"button spaced\">100%</span>\r\n\t\t\t\t\t<button data-canvas-event=\"zoom:0.05\" class=\"button min-plus mini-button\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"ZoomOut"), env.opts.autoescape);
output += "\">+</button>\r\n\t\t\t\t</div>\r\n\t\t\t\t<span>";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"Zoom"), env.opts.autoescape);
output += "</span>\r\n\t\t\t</div>\r\n\t\t\t<div data-toggle-fullscreen=\"true\" class=\"option option-fullscreen\"><span class=\"material-icons\">&#xe5d0;</span>";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"Fullscreen"), env.opts.autoescape);
output += "</div>\r\n\t\t\t<div class=\"option\" data-canvas-event=\"usersettings\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"ChangeAccount"), env.opts.autoescape);
output += "</div>\r\n\t\t\t<div class=\"option\" data-canvas-event=\"logoff\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"Logout"), env.opts.autoescape);
output += "</div>\r\n\t\t</div>\r\n\t</div>\r\n\t";
;
}
output += "\r\n</div>\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["views/interface/nav.html"] , dependencies)